import { render, staticRenderFns } from "./TimeZoneSetting.vue?vue&type=template&id=2d066171&scoped=true&"
import script from "./TimeZoneSetting.vue?vue&type=script&lang=ts&"
export * from "./TimeZoneSetting.vue?vue&type=script&lang=ts&"
import style0 from "./TimeZoneSetting.vue?vue&type=style&index=0&id=2d066171&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d066171",
  null
  
)

export default component.exports